import { createSlice } from "@reduxjs/toolkit";
import { SidebarOptions } from "../../utils/constants/sidebar";
import { reducerPaths } from "src/app/reducerPaths";

const initialState = {
  activeSidebar: SidebarOptions[0],
};

const sidebarSlice = createSlice({
  name: reducerPaths.sidebar,
  initialState,
  reducers: {
    setActiveSidebar: (state, action) => {
      state.activeSidebar = action.payload;
    },
  },
});

export const { setActiveSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
